import React from 'react';
import './board.css';

const SUIT_COLORS = {
    hearts: '#E57373',    
    clubs: '#4CAF50',     
    diamonds: '#497CAB',  
    spades: '#424242'     
};

const Card = ({ value, suit, isRevealed = true }) => (
  <div className={`board-card ${!isRevealed ? 'unrevealed' : ''}`}>
    {isRevealed && (
      <>
        <img 
          src={`/svgs/${suit}.svg`}
          alt={suit} 
          className="card-suit"
          style={{ color: SUIT_COLORS[suit] }}
        />
        <span 
          className="card-value"
          style={{ color: SUIT_COLORS[suit] }}
        >
          {value}
        </span>
      </>
    )}
  </div>
);

const Board = ({ 
  flop1 = { value: 'A', suit: 'spades' },
  flop2 = { value: 'T', suit: 'spades' },
  flop3 = { value: '6', suit: 'diamonds' },
  turn = { value: '', suit: '' },
  river = { value: '', suit: '' },
  isTurnRevealed = false,
  isRiverRevealed = false,
  preflopAction = 'SRP',
  heroPosition = 'LJ',
  villainPosition = 'BTN',
  potSize = '88.5',
  isPotVisible = true
}) => {
  return (
    <div className="board-container">
      {isPotVisible && (
        <div className="pot">
          <img src="/svgs/pot-main.svg" alt="pot chips" className="pot-chips" />
          <div className="pot-amount">
            <span className="dynamic-text">{potSize}</span>
            <span className="static-text">bb</span>
          </div>
        </div>
      )}

      <div className="board">
        <div className="flop">
          <Card value={flop1.value} suit={flop1.suit} isRevealed={true} />
          <Card value={flop2.value} suit={flop2.suit} isRevealed={true} />
          <Card value={flop3.value} suit={flop3.suit} isRevealed={true} />
        </div>
        <div className="turn">
          <Card value={turn.value} suit={turn.suit} isRevealed={isTurnRevealed} />
        </div>
        <div className="river">
          <Card value={river.value} suit={river.suit} isRevealed={isRiverRevealed} />
        </div>
      </div>
      
      <div className="board-info">
        <span className="label">pre-flop</span>
        <span className="dynamic-text">{preflopAction}</span>,{' '}
        <span className="label">hero-position</span>
        <span className="dynamic-text">{heroPosition}</span>
        {' '}vs{' '}
        <span className="label">villain-position</span>
        <span className="dynamic-text">{villainPosition}</span>
      </div>
    </div>
  );
};

export default Board;